import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const pitListService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  cycleId?: string | null;
  templateId?: string | null;
  employeeId?: number | null;
  employeeIds?: number[] | null;
  employeeCode?: string | null;
  employeeCodes?: string[] | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.PIT>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const pitCreateService = (params: {
  year: number;
  month: number;
  templateId: string;
  cycleId: string;
  data: {
    employeeCode?: string;
    employeeFullName?: string;
    employeeEmail?: string;
    amount: number;
    description?: string;
  }[];
}) =>
  RestAPIClient.call<Types.PIT>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const pitUpdateService = (params: {
  id: string;
  amount?: number;
  status?: number;
}) =>
  RestAPIClient.call<Types.PIT>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "id"),
  });

export const pitDetailService = (id: string) =>
  RestAPIClient.call<Types.PIT>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const pitDeleteService = (params: {
  year: number;
  month: number;
  templateId: string;
  cycleId: string;
  data: { employeeCode: string }[];
}) =>
  RestAPIClient.call<{
    employeeCodes?: string[];
    year: number;
    month: number;
    templateId: string;
    cycleId: string;
    isRunPayroll?: boolean;
  }>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "id"),
  });
